import type { Metadata, Viewport } from 'next';

/** Shared site branding strings — keys match MetaInfo's next-i18next literals. */
export const SITE_TITLE = 'Highlight';
export const SITE_DESCRIPTION = 'Highlight Customer Application';
export const SITE_URL = 'https://platform.letshighlight.com/';
export const SITE_LOCALE = 'en_US';
export const THEME_COLOR = '#000000';
export const SITE_TITLE_TEMPLATE = `%s | ${SITE_TITLE}`;

/**
 * Default document metadata for the App Router root layout. Mirrors
 * `MetaInfo` (next-seo DefaultSeo) and the `<head>` links from `_document`.
 */
export const siteMetadata: Metadata = {
  metadataBase: new URL(SITE_URL),
  title: {
    default: SITE_TITLE,
    template: SITE_TITLE_TEMPLATE,
  },
  description: SITE_DESCRIPTION,
  applicationName: SITE_DESCRIPTION,
  icons: {
    icon: [{ url: '/logos/favicon.ico' }],
    shortcut: ['/logos/favicon.ico'],
    apple: [
      { url: '/icons/logo_512.png' },
      { url: '/icons/logo_512.png', sizes: '152x152', type: 'image/png' },
      { url: '/icons/logo_512.png', sizes: '180x180', type: 'image/png' },
      { url: '/icons/logo_512.png', sizes: '167x167', type: 'image/png' },
    ],
  },
  manifest: '/manifest.json',
  openGraph: {
    type: 'website',
    locale: SITE_LOCALE,
    url: SITE_URL,
    siteName: SITE_TITLE,
    title: SITE_TITLE,
    description: SITE_DESCRIPTION,
  },
  twitter: {
    site: '@letshighlight',
    card: 'summary_large_image',
  },
  alternates: {
    languages: {
      en: `${SITE_URL}en`,
    },
  },
  appleWebApp: {
    capable: true,
    statusBarStyle: 'default',
    title: SITE_DESCRIPTION,
  },
  other: {
    'format-detection': 'telephone=no',
    'mobile-web-app-capable': 'yes',
    'msapplication-TileColor': THEME_COLOR,
    'msapplication-tap-highlight': 'no',
  },
};

export const siteViewport: Viewport = {
  themeColor: THEME_COLOR,
  width: 'device-width',
  initialScale: 1,
  minimumScale: 1,
  viewportFit: 'cover',
};
